import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface TalentProfileState {
  isResumeGalleryOpen: boolean;
  isSizeCardOpen: boolean;
  isImageGalleryOpen: boolean;
  isVideoGalleryOpen: boolean;
  isShareProfileOpen: boolean;
}

export const initialState: TalentProfileState = {
  isResumeGalleryOpen: false,
  isSizeCardOpen: false,
  isVideoGalleryOpen: false,
  isImageGalleryOpen: false,
  isShareProfileOpen: false,
};

export const talentProfileSlicer = createSlice({
  name: 'talentProfile',
  initialState,
  reducers: {
    onOpenResumeGallery(state: TalentProfileState) {
      state.isResumeGalleryOpen = true;
    },
    onCloseResumeGallery(state: TalentProfileState) {
      state.isResumeGalleryOpen = false;
    },
    onOpenSizeCard(state: TalentProfileState) {
      state.isSizeCardOpen = true;
    },
    onCloseSizeCard(state: TalentProfileState) {
      state.isSizeCardOpen = false;
    },
    onOpenImageGallery(state: TalentProfileState) {
      state.isImageGalleryOpen = true;
    },
    onCloseImageGallery(state: TalentProfileState) {
      state.isImageGalleryOpen = false;
    },
    onOpenVideoGallery(state: TalentProfileState) {
      state.isVideoGalleryOpen = true;
    },
    onCloseVideoGallery(state: TalentProfileState) {
      state.isVideoGalleryOpen = false;
    },
    onOpenShareProfile(state: TalentProfileState) {
      state.isShareProfileOpen = true;
    },
    onCloseShareProfile(state: TalentProfileState) {
      state.isShareProfileOpen = false;
    },
  },
});

export const selectTalentProfileState = (state: RootState) => state.talentProfile;

export const {
  onOpenResumeGallery,
  onCloseResumeGallery,
  onOpenSizeCard,
  onCloseSizeCard,
  onOpenImageGallery,
  onCloseImageGallery,
  onOpenVideoGallery,
  onCloseVideoGallery,
  onOpenShareProfile,
  onCloseShareProfile,
} = talentProfileSlicer.actions;

export default talentProfileSlicer.reducer;
